export function getMobilePlatform() {
    if (typeof navigator === "undefined") {
        return null;
    }

    const userAgent = navigator.userAgent || "";

    if (/android/i.test(userAgent)) {
        return "android";
    }

    if (
        /iPad|iPhone|iPod/i.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
        return "ios";
    }

    return null;
}
